import type { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './FormButton.module.css';

interface IFormButtonProps {
    automation?: string;
    children?: ReactNode;
    disabled?: boolean;
    onClick?: () => void;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function FormButton(props: IFormButtonProps) {
    let className = styles.normal;

    if (props.disabled) {
        className = styles.disabled;
    }

    return (
        <button
            className={classnames(className, props.automation ? 'automation-' + props.automation : '')}
            disabled={props.disabled}
            onClick={props.onClick}
            type="button"
        >
            {props.children}
        </button>
    );
}
